module.exports = __webpack_public_path__ + "static/david-min-9a8dd6197f9bd9933d3050151efecc9e.png";